module.exports = __webpack_public_path__ + "img/jean_de_berry_cover.eb1d8d60.jpg";